import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import FullMenu from "./FullMenu";
import { Button as UIButton } from "./ui";
import "./Navbar.css";

const Navbar = ({ isMobile, lightMode = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDifference = lastScrollY - currentScrollY;

      // Update scrolled state
      setIsScrolled(currentScrollY > 50);

      // Auto-hide logic - immediate response
      if (currentScrollY < 100) {
        // Always show when near top
        setIsVisible(true);
      } else if (currentScrollY < lastScrollY) {
        // Show navbar immediately when scrolling up
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Hide when scrolling down and past threshold
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  // Track menu open state by observing body classes
  useEffect(() => {
    const checkMenuState = () => {
      const hasFullMenuOpen =
        document.body.classList.contains("full-menu-open");
      const hasNoScroll = document.body.classList.contains("no-scroll");
      setIsMenuOpen(hasFullMenuOpen || hasNoScroll);
    };

    // Check initial state
    checkMenuState();

    // Create a MutationObserver to watch for class changes on body
    const observer = new MutationObserver(checkMenuState);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const handleJetztAnfragenClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling to menu toggle
    // Scroll to CallToActionWithModal component or navigate to contact section
    navigate("/kontakt");
  };

  const routes = [
    { path: "#intro", label: "Start" },
    { path: "#workshop", label: "Werkstatt" },
    { path: "#team", label: "Team" },
    { path: "#project", label: "Projekte" },
    { path: "#appointment", label: "Termine" },
    { path: "#location", label: "Anfahrt" },
  ];

  const scrollToTop = () => {
    // Navigate to home page and scroll to top
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Determine navbar styling based on location and scroll position
  const isLandingPage = location.pathname === "/";
  const isContactPage = location.pathname === "/kontakt";
  const isOffersPage = location.pathname === "/aktuelle-angebote";
  const isArticlePage =
    location.pathname.startsWith("/motorenbau/") ||
    location.pathname.startsWith("/restauration") ||
    location.pathname.startsWith("/leistungssteigerungen") ||
    location.pathname.startsWith("/motorsport") ||
    location.pathname.startsWith("/service-wartung") ||
    location.pathname.startsWith("/porsche-elektronik") ||
    location.pathname.startsWith("/porsche-reparatur") ||
    location.pathname.startsWith("/porsche-gutachten") ||
    location.pathname.startsWith("/porsche-verkaufen");

  const isNotVerwandteArtikel =
    !location.pathname.includes("verwandte-artikel");
  const isAtTopOfLanding =
    (isLandingPage || isContactPage || isArticlePage) &&
    !isScrolled &&
    isNotVerwandteArtikel;

  return (
    <>
      <div
        className={`navbar ${isAtTopOfLanding ? "landing-top" : ""} ${
          lightMode ? "light-mode" : ""
        }`}
        style={{
          transform: "translateY(0)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/${
            lightMode && !isMenuOpen ? "logo-v2-dark.png" : "logo-v2.png"
          }`}
          alt="Logo"
          className="logo"
          onClick={scrollToTop}
          style={{ cursor: "pointer" }} // Optional: to indicate the logo is clickable
        />
        {/* <div className="nav-grid">
        <div className="menu-grid">
          {routes.map((route) => (
            <a
              key={route.path}
              href={route.path}
              className={activeSection === route.path.slice(1) ? "active" : ""}
              onClick={(e) => handleClick(e, route.path)}
            >
              {route.label}
            </a>
          ))}
        </div>
      </div> */}
        <FullMenu routes={routes} lightMode={lightMode} />
        <MobileMenu routes={routes} lightMode={lightMode} />

        {/* Jetzt anfragen button - visible on desktop */}
        {/* <UIButton
          onClick={handleJetztAnfragenClick}
          variant="outline"
          size="medium"
          className="jetzt-anfragen-btn"
          style={{
            position: "absolute",
            right: "40px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            color: lightMode ? "var(--color-primary)" : "white",
            borderColor: lightMode ? "var(--color-primary)" : "white",
            zIndex: 15,
            pointerEvents: "auto",
          }}
        >
          Jetzt anfragen
        </UIButton> */}

        {/* {isPhoneVisible && (
          <div>
            <div className="phone-grid">
              <>
                <WhatsAppButton phoneNumber={"+4915756850714"} pulsate />

                <div>
                  <span className="phone-tag">
                    Persönliche Beratung
                    <br />
                  </span>
                  <a href="tel:+4915756850714" className="phone-number">
                    +49 157 568 50 714
                  </a>
                </div>
              </>
            </div>
            <div className="contact-button">
              <Button type="primary" onClick={handleContactButton}>
                Kontakt
              </Button>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default Navbar;
